module.exports = __webpack_public_path__ + "static/media/odin_pokercode_logo.7b8606d5.png";